import * as React from 'react';
import Svg, {
  SvgProps, Path,
} from 'react-native-svg';

const IEQIcon = (props: SvgProps) => (
  <Svg
    width={11}
    height={12}
    fill="none"
    {...props}
  >
    <Path
      fill={props.fill ?? '#fff'}
      d="M4.899 6.904V1.6a1.6 1.6 0 0 0-3.2 0v5.303a2.8 2.8 0 1 0 3.2 0Zm-.8-2.104h-1.6V1.601a.8.8 0 0 1 1.6 0v3.2Z"
    />
    <Path
      fill={props.fill ?? '#fff'}
      fillRule="evenodd"
      d="M8.5 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 1a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"
      clipRule="evenodd"
    />
  </Svg>
);

export default IEQIcon;
